import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../../@core/auth/jwt/jwtService";

const companyId = process.env.REACT_APP_COMPANY_ID;

export const uploadImage = createAsyncThunk(
  "createEvents/uploadImage",
  async (uploadData, thunkAPI) => {
    const { eventId, formData, identifier, config, index } = uploadData;
    const response = await axiosInstance.request({
      url: `/events/${eventId}/files`,
      method: "post",
      data: formData,
      config,
    });
    return {
      data: response.data,
      identifier: identifier,
    };
  }
);

export const getEvents = createAsyncThunk(
  "createEvents/getEvents",
  async (args, thunkAPI) => {
    const response = await axiosInstance.request({
      url: `/companies/${companyId}/events/manage`,
      method: "get",
      params: { pageNumber: args?.pageNumber },
    });
    return { data: response };
  }
);

export const getSponsors = createAsyncThunk(
  "createEvents/getSponsors",
  async (eventId, thunkAPI) => {
    const response = await axiosInstance.request({
      url: `/events/${eventId}/sponsors`,
      method: "get",
    });
    return { data: response.data };
  }
);

export const addSponsors = createAsyncThunk(
  "createEvents/addSponsors",
  async (args, thunkAPI) => {
    const { data, eventId } = args;
    await axiosInstance.request({
      url: `/events/${eventId}/sponsors`,
      method: "post",
      data,
      params: { companyId },
    });
  }
);

export const deleteSponsors = createAsyncThunk(
  "createEvents/deleteSponsors",
  async (args, thunkAPI) => {
    const { eventId, sponsorId } = args;
    await axiosInstance.request({
      url: `/events/${eventId}/sponsors/${sponsorId}`,
      method: "delete",
    });
  }
);

export const editSponsor = createAsyncThunk(
  "createEvents/editSponsor",
  async (args, thunkAPI) => {
    const { sponsorId, eventId, data } = args;
    await axiosInstance.request({
      url: `/events/${eventId}/sponsors/${sponsorId}`,
      method: "patch",
      data: data,
    });
  }
);

export const setNewEvent = createAsyncThunk(
  "createEvents/setNewEvent",
  async (args, thunkAPI) => {
    const { data } = args;
    await axiosInstance.request({
      url: `/companies/${companyId}/events`,
      method: "post",
      data,
    });
  }
);

export const getEvent = createAsyncThunk(
  "createEvents/getEvent",
  async (eventId) => {
    const response = await axiosInstance.request({
      url: `/companies/${companyId}/events/${eventId}`,
      method: "get",
    });
    return { data: response.data };
  }
);

export const updateEvent = createAsyncThunk(
  "createEvents/updateEvent",
  async (args, thunkAPI) => {
    const { eventId, data } = args;
    await axiosInstance.request({
      url: `/companies/${companyId}/events/${eventId}`,
      method: "patch",
      data: data,
    });
  }
);

export const addConference = createAsyncThunk(
  "createEvents/addConference",
  async (args, thunkAPI) => {
    const { eventId, data } = args;
    await axiosInstance.request({
      url: `/events/${eventId}/conferences`,
      method: "post",
      data: data,
      params: { companyId },
    });
  }
);

export const editConference = createAsyncThunk(
  "createEvents/editConference",
  async (args, thunkAPI) => {
    const { conferenceId, eventId, data } = args;
    await axiosInstance.request({
      url: `/events/${eventId}/conferences/${conferenceId}`,
      method: "patch",
      data,
    });
  }
);

export const getConferences = createAsyncThunk(
  "createEvents/getConferences",
  async (eventId) => {
    const response = await axiosInstance.request({
      url: `/events/${eventId}/conferences`,
      method: "get",
      params: { pageSize: 40 },
    });
    return { data: response.data };
  }
);

export const updateTicket = async (args, data) => {
  const { id, eventId: eventId } = args;
  await axiosInstance.patch(`/events/${eventId}/tickets/${id}`, data, {});
};

export const getSpeakers = createAsyncThunk(
  "createEvents/getSpeakers",
  async (eventId) => {
    const response = await axiosInstance.request({
      url: `/events/${eventId}/speakers`,
      method: "get",
      params: { pageSize: 30 },
    });
    return { data: response.data };
  }
);

export const editSpeaker = createAsyncThunk(
  "createEvents/editSpeaker",
  async (args, thunkAPI) => {
    const { speakerId, eventId, data } = args;
    await axiosInstance.request({
      url: `/events/${eventId}/speakers/${speakerId}`,
      method: "patch",
      data: data,
    });
  }
);

export const addSpeakers = createAsyncThunk(
  "createEvents/addSpeakers",
  async (args, thunkAPI) => {
    const { eventId, data } = args;
    await axiosInstance.request({
      url: `/events/${eventId}/speakers`,
      params: { companyId },
      method: "post",
      data: data,
    });
  }
);

export const deleteSpeakers = createAsyncThunk(
  "createEvents/deleteSpeakers",
  async (args, thunkAPI) => {
    const { eventId, speakerId } = args;
    await axiosInstance.request({
      url: `/events/${eventId}/speakers/${speakerId}`,
      method: "delete",
      params: { companyId },
    });
  }
);

export const deleteSpeakers_ = async (id, eventId) => {
  await axiosInstance.delete(`/events/${eventId}/speakers/${id}`, "");
};

export const deleteCofenrence = createAsyncThunk(
  "createEvents/deleteConference",
  async (args, thunkAPI) => {
    const { eventId, conferenceId } = args;
    await axiosInstance.request({
      url: `/events/${eventId}/conferences/${conferenceId}`,
      method: "delete",
      params: { companyId },
    });
  }
);

export const deleteCofenrence_ = async (id, eventId) => {
  await axiosInstance.delete(`/events/${eventId}/conferences/${id}`, "");
};

export const deleteEvent = createAsyncThunk(
  "createEvents/deleteEvent",
  async (args, thunkAPI) => {
    const { eventId } = args;
    await axiosInstance.request({
      url: `/companies/${companyId}/events/${eventId}`,
      method: "delete",
    });
  }
);

export const getSponsorGroup = createAsyncThunk(
  "createEvents/getSponsorGroup",
  async (eventId, thunkAPI) => {
    const response = await axiosInstance.request({
      url: `/events/${eventId}/sponsorgroups`,
      method: "get",
    });
    return { data: response };
  }
);

export const createEventSlice = createSlice({
  name: "createEvents",
  initialState: {
    list: [],
    event: {
      venues: [],
      images: [],
      speakers: [],
      sponsors: [],
      settings: {},
      conferences: [],
      frequentQuestions: [],
      contactInformation: {},
    },
    contact: [],
    imgLogo: [],
    gallery: [],
    speakers: [],
    sponsors: [],
    eventList: [],
    imgBanner: [],
    eventData: [],
    hasMore: false,
    imgSpeaker: [],
    conferences: [],
    sponsorGroup: [],
    addLoader: false,
    imgDescription: [],
    eventLoader: false,
    uploadStatus: false,
    frecuentQuestions: [],
    pendingSpeakers: false,
    addSpeakerloader: false,
    pendingConference: false,
    editSpeakerloader: false,
    editSponsorloader: false,
    deleteEventloader: false,
    createEventloader: false,
    deleteSpeakerloader: false,
    addConferenceloader: false,
    editConferenceloader: false,
    deleteConferenceloader: false,
  },
  reducers: {
    setCreateEventsList: (state, action) => {
      state.list = action.payload;
    },
    clearEventList: (state, action) => {
      state.eventList = [];
    },
    setEvent: (state, action) => {
      state.event = action.payload;
    },
    setClearEvent: (state, action) => {
      state.event = {
        venues: [],
        images: [],
        speakers: [],
        sponsors: [],
        settings: {},
        conferences: [],
        frequentQuestions: [],
        contactInformation: {},
      };
    },
    setSpeakersList: (state, action) => {
      const found = JSON.parse(JSON.stringify(state.speakers)).findIndex(
        (e) => e.id === action.payload.id
      );

      let defValue = JSON.parse(localStorage.getItem("createEventSpeakers"));
      const foundCoo = defValue?.findIndex((e) => e.id === action.payload.id);

      if (found > -1 || foundCoo > -1) {
        defValue[foundCoo] = action.payload;
        state.speakers[found] = action.payload;
      } else if (defValue === null) {
        defValue = [];
        defValue?.push(action.payload);
        state.speakers.push(action.payload);
      } else {
        defValue?.push(action.payload);
        state.speakers.push(action.payload);
      }

      localStorage.setItem("createEventSpeakers", JSON.stringify(defValue));
    },
    deleteSpeaker: (state, action) => {
      const found = JSON.parse(JSON.stringify(state.speakers)).findIndex(
        (e) => e.id === action.payload
      );

      if (found > -1) {
        state.speakers.splice(found, 1);
      }

      const defValue = JSON.parse(localStorage.getItem("createEventSpeakers"));
      const foundCoo = defValue?.findIndex((e) => e.id === action.payload);
      if (foundCoo > -1) {
        defValue.splice(foundCoo, 1);
      }
      localStorage.setItem("createEventSpeakers", JSON.stringify(defValue));
    },
    setConferencesList: (state, action) => {
      const found = JSON.parse(JSON.stringify(state.conferences)).findIndex(
        (e) => e.id === action.payload.id
      );

      let defValue = JSON.parse(localStorage.getItem("createEventConference"));
      const foundCoo = defValue?.findIndex((e) => e.id === action.payload.id);

      if (found > -1 || foundCoo > -1) {
        defValue[foundCoo] = action.payload;
        state.conferences[found] = action.payload;
      } else if (defValue === null) {
        defValue = [];
        defValue?.push(action.payload);
        state.conferences.push(action.payload);
      } else {
        defValue?.push(action.payload);
        state.conferences.push(action.payload);
      }

      localStorage.setItem("createEventConference", JSON.stringify(defValue));
    },
    deleteConference: (state, action) => {
      const found = JSON.parse(JSON.stringify(state.conferences)).findIndex(
        (e) => e.id === action.payload
      );

      const defValue = JSON.parse(
        localStorage.getItem("createEventConference")
      );
      const foundCoo = defValue.findIndex((e) => e.id === action.payload);
      if (foundCoo > -1 || found > -1) {
        defValue.splice(foundCoo, 1);
        state.conferences.splice(found, 1);
      }
      localStorage.setItem("createEventConference", JSON.stringify(defValue));
    },
    setSponsorsList: (state, action) => {
      const found = JSON.parse(JSON.stringify(state.sponsors)).findIndex(
        (e) => e.id === action.payload.id
      );

      let defValue = JSON.parse(localStorage.getItem("createEventSponsor"));
      const foundCoo = defValue?.findIndex((e) => e.id === action.payload.id);

      if (found > -1 || foundCoo > -1) {
        defValue[foundCoo] = action.payload;
        state.sponsors[found] = action.payload;
      } else if (defValue === null) {
        defValue = [];
        defValue?.push(action.payload);
        state.sponsors.push(action.payload);
      } else {
        defValue?.push(action.payload);
        state.sponsors.push(action.payload);
      }

      localStorage.setItem("createEventSponsor", JSON.stringify(defValue));
    },
    deleteSponsor: (state, action) => {
      const found = JSON.parse(JSON.stringify(state.sponsors)).findIndex(
        (e) => e.id === action.payload
      );

      const defValue = JSON.parse(localStorage.getItem("createEventSponsor"));
      const foundCoo = defValue.findIndex((e) => e.id === action.payload);

      if (foundCoo > -1 || found > -1) {
        defValue.splice(foundCoo, 1);
        state.sponsors.splice(found, 1);
      }

      localStorage.setItem("createEventSponsor", JSON.stringify(defValue));
    },
    setFrecuentQList: (state, action) => {
      let defValue = [];
      const found = JSON.parse(
        JSON.stringify(state.frecuentQuestions)
      ).findIndex((e) => e.id === action.payload.id);

      defValue = JSON.parse(localStorage.getItem("createEventFrecuentQ"));

      const foundCoo = defValue?.findIndex((e) => e.id === action.payload.id);

      if (found > -1 || foundCoo > -1) {
        defValue[foundCoo] = action.payload;
        state.frecuentQuestions[found] = action.payload;
      } else {
        if (defValue === null) {
          defValue = [];
          defValue.push(action.payload);
          state.frecuentQuestions.push(action.payload);
        } else {
          state.frecuentQuestions.push(action.payload);
          defValue.push(action.payload);
        }
      }

      localStorage.setItem("createEventFrecuentQ", JSON.stringify(defValue));
    },
    deleteFrecuentQ: (state, action) => {
      const found = JSON.parse(
        JSON.stringify(state.frecuentQuestions)
      ).findIndex((e) => e.id === action.payload);
      const defValue = JSON.parse(localStorage.getItem("createEventFrecuentQ"));
      const foundCoo = defValue.findIndex((e) => e.id === action.payload);

      if (foundCoo > -1 || found > -1) {
        state.frecuentQuestions.splice(foundCoo, 1);
        defValue.splice(foundCoo, 1);
      }
      localStorage.setItem("createEventFrecuentQ", JSON.stringify(defValue));
    },
    setContactList: (state, action) => {
      localStorage.setItem(
        "createEventContact",
        JSON.stringify(action.payload)
      );
    },
    deleteContact: (state, action) => {
      const found = JSON.parse(JSON.stringify(state.contact)).findIndex(
        (e) => e.id === action.payload
      );
      if (found > -1) {
        state.contact.splice(found, 1);
      }
    },
    setGalleryList: (state, action) => {},
    deleteGallery: (state, action) => {
      const found = JSON.parse(JSON.stringify(state.gallery)).findIndex(
        (e) => e.id === action.payload
      );
      const defValue = JSON.parse(localStorage.getItem("createEventGallery"));
      const foundCoo = defValue.findIndex((e) => e.id === action.payload);

      if (foundCoo > -1 || found > -1) {
        state.gallery.splice(foundCoo, 1);
        defValue.splice(foundCoo, 1);
      }
      localStorage.setItem("createEventGallery", JSON.stringify(defValue));
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(uploadImage.fulfilled, (state, action) => {
        const { data, identifier, index } = action.payload;
        if (identifier === 1) {
          localStorage.setItem(
            "imgLogo",
            JSON.stringify({ id: data.id, uri: data.uri })
          );
        } else if (identifier === 2) {
          localStorage.setItem(
            "imgBanner",
            JSON.stringify({ id: data.id, uri: data.uri })
          );
        } else if (identifier === 3) {
          localStorage.setItem(
            "imgDescription",
            JSON.stringify({ id: data.id, uri: data.uri })
          );
        } else if (identifier === 4) {
          let defValue = JSON.parse(
            localStorage.getItem("createEventImgSpeaker")
          );
          const foundCoo = defValue?.findIndex((e) => e.index === index);

          if (defValue === null) {
            defValue = [];
            defValue[0] = { id: data.id, uri: data.uri, index: index };
          } else if (foundCoo > -1) {
            defValue[foundCoo] = { id: data.id, uri: data.uri, index: index };
          } else {
            defValue.push({ id: data.id, uri: data.uri, index: index });
          }

          localStorage.setItem(
            "createEventImgSpeaker",
            JSON.stringify(defValue)
          );
        } else if (identifier === 5) {
          let defValue = JSON.parse(
            localStorage.getItem("createEventImgSponsor")
          );

          const foundCoo = defValue?.findIndex((e) => e.index === index);
          if (defValue === null) {
            defValue = [];
            defValue[0] = { id: data.id, uri: data.uri, index: index };
          } else if (foundCoo > -1) {
            defValue[foundCoo] = { id: data.id, uri: data.uri, index: index };
          } else {
            defValue.push({ id: data.id, uri: data.uri, index: index });
          }

          localStorage.setItem(
            "createEventImgSponsor",
            JSON.stringify(defValue)
          );
        } else if (identifier === 6) {
          let defValue = JSON.parse(localStorage.getItem("createEventGallery"));
          state.gallery.push({ id: data.id, uri: data.uri });

          if (defValue === null) {
            defValue = [];
            defValue.push({ id: data.id, uri: data.uri });
          } else {
            defValue.push({ id: data.id, uri: data.uri });
          }
          localStorage.setItem("createEventGallery", JSON.stringify(defValue));
        }
        state.uploadStatus = false;
      })
      .addCase(uploadImage.pending, (state, { meta }) => {
        state.uploadStatus = true;
        if (meta.arg?.identifier === 6) {
        }
      })
      .addCase(getEvents.fulfilled, (state, action) => {
        state.eventList = [...state.eventList, ...action.payload?.data?.data];
        state.eventLoader = false;
        state.hasMore =
          JSON.parse(action?.payload?.data?.headers["x-pagination"])
            .currentPage !==
          JSON.parse(action?.payload?.data?.headers["x-pagination"]).totalPages;
      })
      .addCase(getEvents.pending, (state, action) => {
        state.eventLoader = true;
      })
      .addCase(getEvents.rejected, (state, action) => {
        state.eventLoader = false;
      })
      .addCase(getEvent.fulfilled, (state, action) => {
        state.eventData = action.payload.data;
      })
      .addCase(getEvent.pending, (state, action) => {
        // state.eventLoader = true
      })
      .addCase(updateEvent.fulfilled, (state, action) => {
        // state.eventData = action.payload.data
      })
      .addCase(updateEvent.pending, (state, action) => {
        // state.eventLoader = true
      })
      .addCase(addConference.fulfilled, (state, action) => {
        state.addConferenceloader = false;
      })
      .addCase(addConference.pending, (state, action) => {
        state.addConferenceloader = true;
      })
      .addCase(addConference.rejected, (state, action) => {
        state.addConferenceloader = false;
      })
      .addCase(editConference.fulfilled, (state, action) => {
        state.editConferenceloader = false;
        state.conferences = [];
      })
      .addCase(editConference.pending, (state, action) => {
        state.editConferenceloader = true;
      })
      .addCase(editConference.rejected, (state, action) => {
        state.editConferenceloader = false;
      })
      .addCase(getSpeakers.fulfilled, (state, action) => {
        state.speakers = action.payload.data;
        state.pendingSpeakers = false;
      })
      .addCase(getSpeakers.pending, (state, action) => {
        state.speakers = [];
        state.pendingSpeakers = true;
      })
      .addCase(getSpeakers.rejected, (state, action) => {
        state.speakers = [];
        state.pendingSpeakers = false;
      })
      .addCase(editSpeaker.fulfilled, (state, action) => {
        state.editSpeakerloader = false;
        state.speakers = [];
      })
      .addCase(editSpeaker.pending, (state, action) => {
        state.editSpeakerloader = true;
      })
      .addCase(editSpeaker.rejected, (state, action) => {
        state.editSpeakerloader = false;
      })
      .addCase(addSpeakers.fulfilled, (state, action) => {
        state.addSpeakerloader = false;
        state.speakers = [];
      })
      .addCase(addSpeakers.rejected, (state, action) => {
        state.addSpeakerloader = false;
        state.speakers = [];
      })
      .addCase(addSpeakers.pending, (state, action) => {
        state.addSpeakerloader = true;
      })
      .addCase(deleteSpeakers.fulfilled, (state, action) => {
        state.deleteSpeakerloader = false;
        state.speakers = [];
      })
      .addCase(deleteSpeakers.pending, (state, action) => {
        state.deleteSpeakerloader = true;
      })
      .addCase(deleteCofenrence.fulfilled, (state, action) => {
        state.deleteConferenceloader = false;
        state.conferences = [];
      })
      .addCase(deleteCofenrence.pending, (state, action) => {
        state.deleteConferenceloader = true;
      })
      .addCase(getConferences.fulfilled, (state, action) => {
        state.conferences = action.payload.data;
        state.pendingConference = false;
      })
      .addCase(getConferences.pending, (state, action) => {
        state.pendingConference = true;
      })
      .addCase(getConferences.rejected, (state, action) => {
        state.pendingConference = false;
      })
      .addCase(getSponsors.fulfilled, (state, action) => {
        state.sponsors = action.payload.data;
      })
      .addCase(getSponsors.pending, (state, action) => {
        // state.sponsors = true;
      })
      .addCase(getSponsors.rejected, (state, action) => {
        // state.sponsors = false;
      })
      .addCase(addSponsors.fulfilled, (state, action) => {
        state.addLoader = false;
      })
      .addCase(addSponsors.pending, (state, action) => {
        state.addLoader = true;
      })
      .addCase(addSponsors.rejected, (state, action) => {
        state.addLoader = false;
      })
      .addCase(deleteSponsors.fulfilled, (state, action) => {
        state.addLoader = false;
      })
      .addCase(deleteSponsors.pending, (state, action) => {
        state.addLoader = true;
      })
      .addCase(deleteSponsors.rejected, (state, action) => {
        state.addLoader = false;
      })
      .addCase(setNewEvent.fulfilled, (state, action) => {
        state.createEventloader = false;
      })
      .addCase(setNewEvent.pending, (state, action) => {
        state.createEventloader = true;
      })
      .addCase(setNewEvent.rejected, (state, action) => {
        state.createEventloader = false;
      })
      .addCase(deleteEvent.fulfilled, (state, action) => {
        state.deleteEventloader = false;
      })
      .addCase(deleteEvent.pending, (state, action) => {
        state.deleteEventloader = true;
      })
      .addCase(deleteEvent.rejected, (state, action) => {
        state.deleteEventloader = false;
      })
      .addCase(getSponsorGroup.fulfilled, (state, action) => {
        state.sponsorGroup = action.payload?.data?.data;
      })
      .addCase(getSponsorGroup.pending, (state, action) => {
        // state.sponsorGroup = true;
      })
      .addCase(getSponsorGroup.rejected, (state, action) => {
        // state.sponsorGroup = false;
      })
      .addCase(editSponsor.fulfilled, (state, action) => {
        state.editSponsorloader = false;
      })
      .addCase(editSponsor.pending, (state, action) => {
        state.editSponsorloader = true;
      })
      .addCase(editSponsor.rejected, (state, action) => {
        state.editSponsorloader = false;
      });
  },
});

export const {
  setEvent,
  deleteSpeaker,
  deleteSponsor,
  deleteContact,
  setClearEvent,
  deleteGallery,
  setContactList,
  clearEventList,
  setSponsorsList,
  setSpeakersList,
  deleteFrecuentQ,
  deleteConference,
  setFrecuentQList,
  setConferencesList,
  setCreateEventsList,
} = createEventSlice.actions;

export default createEventSlice.reducer;
